import { LocalDate } from '../../core/model/local-date';
import { ModelBase } from '../../core/model/model-base';
import { Money } from '../../core/model/money';
import { IncorrectPaymentTransaction } from './incorrect-payment-transaction';
import { InvoiceAccounting } from './invoice-accounting';

export class IncorrectPayment extends ModelBase {
  constructor() {
    super();
    this.incorrectPaymentTransactions = [];
    this._accounting = [];

    Object.defineProperties(this, {
      _accounting: { enumerable: false, writable: true },
      _creationDate: { enumerable: false, writable: true },
      _businessTransactionDate: { enumerable: false, writable: true },
    });
  }

  incorrectPaymentTransactions: IncorrectPaymentTransaction[];

  private _creationDate: LocalDate;
  private _businessTransactionDate: LocalDate;
  private _accounting: InvoiceAccounting[];
  private _companyAccountingClosedTo: LocalDate;

  get accountingTransactions(): InvoiceAccounting[] {
    return this._accounting;
  }
  set accountingTransactions(accountingItems: InvoiceAccounting[]) {
    if (accountingItems) {
      accountingItems.forEach(accountingItem => {
        if (accountingItem instanceof InvoiceAccounting) {
          this._accounting.push(accountingItem);
        } else {
          this._accounting.push(Object.assign(new InvoiceAccounting(), accountingItem));
        }
      });
    }
  }

  amount: Money;
  balance: Money;
  get creationDate(): LocalDate {
    return this._creationDate;
  }
  set creationDate(value: LocalDate) {
    this._creationDate = LocalDate.fromDate(value);
  }

  get businessTransactionDate(): LocalDate {
    return this._businessTransactionDate;
  }
  set businessTransactionDate(value: LocalDate) {
    this._businessTransactionDate = LocalDate.fromDate(value);
  }

  get companyAccountingClosedToDate(): LocalDate {
    return this._companyAccountingClosedTo;
  }
  set companyAccountingClosedToDate(value: LocalDate) {
    this._companyAccountingClosedTo = LocalDate.fromDate(value);
  }

  description: string;
  payer: string;
  payerName: string;
  payerNameAndAddress: string;
  companyId?: string;
  companyName: string;
  bankgiroNumber: string;
  ocr: string;
  registrationTypeText: string;
}
